import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";

/* =======================
   Styles
======================= */
import styles from "./PieChart.module.scss";

// Hardcoded JS values for Recharts, matching our new SCSS variables
const CHART_COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#8b5cf6", "#ec4899"];
const EMPTY_COLOR = "#e2e8f0";

function CategoryPie({ pieGraphData = [] }) {
  const pieData = pieGraphData.map((item) => ({
    name: item.category,
    value: Number(item.hit_percentage) || 0,
  }));

  const hasData = pieData.length && pieData.some((d) => d.value > 0);
  const chartData = hasData ? pieData : [{ name: "No Data", value: 100 }];

  return (
    <div className={styles["admin-pie-chart"]}>
      <div className={styles["admin-pie-chart__container"]}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius="60%" /* Creates the Donut hole */
              outerRadius="80%"
              paddingAngle={4} /* Space between slices */
              cornerRadius={6} /* Rounded modern edges for slices */
              dataKey="value"
              stroke="none" /* Removes harsh borders */
              label={({ percent }) =>
                hasData ? `${(percent * 100).toFixed(2)}%` : ""
              }
            >
              {chartData.map((_, i) => (
                <Cell
                  key={`cell-${i}`}
                  fill={
                    hasData
                      ? CHART_COLORS[i % CHART_COLORS.length]
                      : EMPTY_COLOR
                  }
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* Legend */}
      {pieData.length > 0 && (
        <div className={styles["admin-pie-chart__legend"]}>
          {pieData.map((item, index) => (
            <div key={index} className={styles["admin-pie-chart__legend-item"]}>
              <div
                className={styles["admin-pie-chart__legend-color"]}
                style={{
                  backgroundColor: CHART_COLORS[index % CHART_COLORS.length],
                }}
              />
              <span className={styles["admin-pie-chart__legend-label"]}>
                {item.name}
              </span>
              <span className={styles["admin-pie-chart__legend-value"]}>
                {item.value}%
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default React.memo(CategoryPie);
